// src/crm/components/ContactTypeBadge.tsx
import type { ContactType } from '../../lib/types'

export const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  ugc_creator: 'Créateur UGC',
  press: 'Presse',
  partner: 'Partenaire',
  sponsor: 'Sponsor',
}

const COLORS: Record<ContactType, { bg: string; fg: string }> = {
  ugc_creator: { bg: 'rgba(217,83,30,0.12)', fg: 'var(--arancio)' },
  press: { bg: 'rgba(42,103,141,0.15)', fg: '#5FA8D3' },
  partner: { bg: 'rgba(140,120,60,0.15)', fg: '#C9A84C' },
  sponsor: { bg: 'rgba(90,140,90,0.15)', fg: '#7FBF7F' },
}

export function ContactTypeBadge({ type }: { type: ContactType }) {
  const c = COLORS[type]
  return (
    <span
      style={{
        display: 'inline-block',
        background: c.bg,
        color: c.fg,
        borderRadius: '5px',
        padding: '0.125rem 0.5rem',
        fontSize: '0.75rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {CONTACT_TYPE_LABELS[type]}
    </span>
  )
}
